import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'

import DollarIcon from '../../../shared/components/icons/dollar'
import SearchIcon from '../../../shared/components/icons/search'
import RightOpenIcon from '../../../shared/components/icons/rightOpen'

class FiltersPrice extends React.Component {
  static propTypes = {
    cost: PropTypes.object,
    locationParams: PropTypes.object.isRequired,
    makeSearchLink: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    const { locationParams } = props

    this.state = {
      priceMin: locationParams ? locationParams.price_min : '',
      priceMax: locationParams ? locationParams.price_max : ''
    }
  }

  onPriceMinChange(event) {
    this.setState({ priceMin: event.target.value })
  }

  onPriceMaxChange(event) {
    this.setState({ priceMax: event.target.value })
  }

  onSubmit() {
    const { locationParams, makeSearchLink } = this.props

    let nextQuery = Object.assign({}, locationParams, {
      price_min: this.state.priceMin,
      price_max: this.state.priceMax
    })
    delete nextQuery.page

    if (!this.state.priceMin) {
      delete nextQuery.price_min
    }

    if (!this.state.priceMax) {
      delete nextQuery.price_max
    }

    this.props.history.push(makeSearchLink(nextQuery))
  }

  onEnter(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.onSubmit()
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextQuery = nextProps.locationParams

    if (nextQuery.price_min !== this.state.priceMin) {
      this.setState({ priceMin: nextQuery.price_min || '' })
    }

    if (nextQuery.price_max !== this.state.priceMax) {
      this.setState({ priceMax: nextQuery.price_max || '' })
    }
  }

  render() {
    const { isAtTop } = this.props
    const panelHeaderClassNames = classNames({
      'search-facet-panel__header--start': isAtTop,
      'search-facet-box__inner': !isAtTop
    })
    const searchFacetBoxClassNames = classNames({
      'search-facet-box': !isAtTop
    })

    return (
      <div className="search-facet--no-margin" id="price-filter">
        <div className={searchFacetBoxClassNames}>
          <div className={panelHeaderClassNames}>
            <h2 className="search-facet-box__heading">
              <DollarIcon /> Price
              <span style={{ float: 'right' }}>
                <RightOpenIcon />
              </span>
            </h2>
            <div className="search-facet-range__inputs">
              <div className="search-facet-range__input--with-prefix">
                <label>From</label>
                <span>$</span>
                <input
                  aria-label="Minimum price"
                  type="number"
                  className="e-input"
                  placeholder={this.props.cost ? this.props.cost.min / 100 : ''}
                  value={this.state.priceMin}
                  onChange={this.onPriceMinChange.bind(this)}
                  onKeyPress={this.onEnter.bind(this)}
                />
              </div>
              <div className="search-facet-range__input--with-prefix">
                <label>To</label>
                <span>$</span>
                <input
                  aria-label="Maximum price"
                  type="number"
                  className="e-input"
                  placeholder={this.props.cost ? this.props.cost.max / 100 : ''}
                  value={this.state.priceMax}
                  onChange={this.onPriceMaxChange.bind(this)}
                  onKeyPress={this.onEnter.bind(this)}
                />
              </div>
              <div className="search-facet-range__input--submit">
                <button
                  type="button"
                  className="fds-c-button fds-u-p0 no-label"
                  onClick={this.onSubmit.bind(this)}
                >
                  <SearchIcon title="Apply" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export const FiltersPriceComponent = FiltersPrice
export default withRouter(FiltersPrice)
